<template>
	<c-dialog ref="dialog" width="100vw-300" mode="slide" mask-close @close="dialogFormEditConfirm($refs.stockoutForm, arguments)" @resolve="editHandle">
		<c-form ref="stockoutForm" column="3" vertical unit-width="100%">
			<c-title>基本信息</c-title>
			<c-form link-parent>
				<c-form-column>
					<c-form-item label="出库单号">
						<c-input name="order_code" placeholder="请输入，忽略将自动生成"></c-input>
					</c-form-item>
					<c-form-item label="出库时间" required>
						<c-datetime name="storage_date" type="datetime" format="yyyy-MM-dd hh:mm" time-accuracy="min" placeholder="请选择实际出库时间" v-model="storage_date"></c-datetime>
					</c-form-item>
				</c-form-column>

				<c-form-column>
					<c-form-item label="仓库" required>
						<c-select ref="warehouse" name="warehouse_id" v-model="warehouse_id" async @search="searchWarehouse"  :value-data="warehouseOptions" :disabled="this.order_id>0" :clear="false"></c-select>
						<template #handle>
							<c-tooltip tip="仓库切换将清空出库明细商品，请谨慎操作" position="top"></c-tooltip>
						</template>
					</c-form-item>
					<c-form-item label="出库类型" required>
						<c-select name="order_classify" v-model="order_classify" :options="stockoutClassifyName" :disabled="this.ref_type!=0"  :clear="false"></c-select>
					</c-form-item>
				</c-form-column>

				<c-form-column>
					<c-form-item label="备注">
						<c-input type="textarea" name="remark"></c-input>
					</c-form-item>
					<c-form-item label="客户名称" v-show="order_classify==21">
						<c-select name="customer_id" async @search="searchCustomer" :value-data="customerOptions"></c-select>
						<template #handle>
							<c-link icon v-if="auth('b_customer_edit')" @click="globalDialog('customerEdit',{})">创建客户</c-link>
						</template>
					</c-form-item>
					<c-form-item label="供应商" v-show="order_classify==24">
						<c-select name="supplier_id" async :value-data="supplierOptions" @search="searchSupplier"></c-select>
						<template #handle>
							<c-link icon v-if="auth('b_supplier_edit')" @click="globalDialog('supplierEdit',{})">创建供应商</c-link>
						</template>
					</c-form-item>
				</c-form-column>

				<!--自定义字段-->
				<custom-form ref="customForm" work-type="20"></custom-form>
			</c-form>
			<c-title >出库明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" :view-id="view_id" work-type="21">
					<template #operate>
						<c-button color="main" v-if="auth('b_stockout_edit') && systemConfig.batch_stock == 1" v-lock="lock('b_stockout_edit')" prepend-icon="tf-add" @click="selectProductBatch()">选择产品批次库存</c-button>
						<c-button color="main" v-else-if="auth('b_stockout_edit')" v-lock="lock('b_stockout_edit')" prepend-icon="tf-add" @click="selectProduct()">选择产品</c-button>
					</template>
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					<!--商品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					<!--出库数量-->
					<template #view_product_count="{data}">
						<c-input name="view_product_count" type="stepper" decimal="6" :range="[0,99999999]" v-model="data.view_product_count"></c-input>
					</template>
					<!--成本单价-->
					<template #product_price="{data}">
						<span v-if="ref_type==32 || ref_type == 39 || systemConfig.batch_stock == 1">{{data.product_price}}</span>
						<c-input v-else type="number" decimal="6" :range="[0,99999999]" v-model="data.product_price"></c-input>
					</template>
					<c-table-column
                        type="button"
                        label="操作"
                    >
                        <template #default="{data,remove}">
							<c-table-button v-if="auth('b_stockout_edit')" v-lock="lock('b_stockout_edit')" icon="tf-trash" color="red" @click="removeRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'b_stockout_edit',
	computed: {
		// 获取dictName选项数据
		...mapState(['stockoutClassifyName', 'systemConfig']),
	},
	// 监听器
	watch: {
		//仓库变更，清除商品列表
		warehouse_id() {
			if (this.order_id == 0 || !this.order_id){
				this.$refs.productTable.$refs.list.setData([]);
			}
		}
	},

	data() {
		return {
			view_id:10006,
			order_id:0,
			storage_date:'',
			productList:[],
			deleteProductList:[],
			warehouseOptions:[],
			ref_type:0, //关联单据类型（0：自建，14：报工）
			order_classify:0,
			warehouse_id:0,
			customerOptions: [],//已选中的客户信息
			supplierOptions: []//已选中的供应商信息
		}
	},
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data) {
			//自定义字段控件初始化
			this.$refs.customForm.init({
				formulaSource: {
					name: '出入库单',
					form: this.$refs.stockoutForm,
					watch: {
						'order_classify': (data, resolve) => {
							resolve({
								'客户': {},
								'供应商': {}
							});
						},
						'customer_id': (data, resolve) => {
							data.customer_id && this.request({
								url: '/customer/detail',
								data: {
									id: data.customer_id
								},
								success: data => {
									resolve({
										'客户': data
									});
								}
							});
						},
						'supplier_id': (data, resolve) => {
							data.supplier_id && this.request({
								url: '/supplier/detail',
								data: {
									id: data.supplier_id
								},
								success: data => {
									resolve({
										'供应商': data
									});
								}
							});
						}
					},
					update: data => {
						this.$refs.productTable.setFormulaSource({
							'出入库单': data
						});
					}
				}
			});
			//初始化产品列表控件
			this.$refs.productTable.init({
				formulaSource: {
					name: '出入库单明细'
				}
			});

			this.deleteProductList = [];
			this._editState = !!data;
			this.$refs.stockoutForm.clear();
			if (data) {
				this.order_id = data.id;
				this.getDetail();
			}else {
				this.order_id = 0;
				this.ref_type = 0;
				this.$refs.stockoutForm.set({
					storage_date: new Date().format('yyyy-MM-dd hh:mm'),
					order_classify: 20
				});
				//选中默认仓库
				this.getDefaultWarehouse();
			}
			this.$refs.dialog.open({
				title: data ? '编辑出库单' : '创建出库单'
			});
		},


		/*******搜索【客户】下拉框信息*****************/
		searchCustomer(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'CUSTOMER',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索【供应商】下拉框信息*****************/
		searchSupplier(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SUPPLIER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索出库单详情*******************/
		getDetail() {
			this.request({
				url:'/stockout/order/detail',
				data: {
					id: this.order_id
				},
				loading: true,
				success: data => {
					this.$refs.stockoutForm.set(data);
					this.storage_date = data.storage_date;
					this.ref_type = data.ref_type;
					if (data && data.warehouse_id && data.warehouse_name){
						this.warehouseOptions = [{
							name:data.warehouse_name + ' | ' + data.warehouse_code,
							value:data.warehouse_id
						}];
						console.log(this.warehouseOptions)
					}else {
						this.warehouseOptions = [];
					}
					if (data && data.customer_id && data.customer_name){
						this.customerOptions = [{
							name:data.customer_code +' - ' +data.customer_name,
							value:data.customer_id
						}];
					}else {
						this.customerOptions = [];
					}
					if (data && data.supplier_id && data.supplier_name){
						this.supplierOptions = [{
							name:data.supplier_code +' - ' +data.supplier_name,
							value:data.supplier_id
						}];
					}else {
						this.supplierOptions = [];
					}
					//查询产品列表
					this.getProductList();
				}
			});
		},

		getProductList() {
			this.request({
				url:'/stockout/order/product/list',
				data: {
					view_id:this.view_id,
					id: this.order_id
				},
				loading: true,
				success: data => {
					var productList = data.map(item => {
						var obj = item;
						obj.is_db = 1;
						obj.old_product_count = item.view_product_count||0;
						return obj;
					});
					this.$refs.productTable.$refs.list.setData(productList);
				}
			});
		},
		/***
		 **查询默认仓库
		 **/
		getDefaultWarehouse(){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE'
				},
				success:data => {
					if (data.length == 1){
						this.warehouseOptions = [data[0]];
						this.warehouse_id = data[0].value;
					}
				}
			});
		},

		/*******搜索【仓库】下拉框信息*****************/
		searchWarehouse(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/******删除行数据********/
		removeRow(data, remove) {
			if (data.is_db == 1 && data.id && data.id > 0){
				this.deleteProductList.push(data.id);
			}
			remove();
		},

		/******打开选择产品弹窗*********/
		selectProduct(){
			if (this.warehouse_id == 0){
				this.$message({
					message:'请选择出库仓库',  // 提示内容,
					type: 'warn'
				});
			}else {
				this.globalDialog('productSelector', {
					props: {
						warehouseOptions: [this.$refs.warehouse.getData()]
					}
				}, this.productSelectorHandle)
			}
		},

		/******选择产品响应方法*********/
		async productSelectorHandle(data) {
			//判断是否已存在于表格之中，已存在则不允许添加
			for (var i = 0; i < data.length; i++) {
				var newProduct = data[i];
				var existObj = this.$refs.productTable.$refs.list.getData().find(function (obj) {
					return obj.product_id == newProduct.id
				});
				if (existObj){
					this.$message({
						type:'warn',
						message:'产品【'+existObj.product_code+' | '+existObj.product_name+'】已存在，请勿重复添加',
					});
					return;
				}
			}
			//处理数据
			this.$refs.productTable.$refs.list.push(
				await this.$refs.productTable.setDefaultData(data.map(item => {
					return Object.assign({}, item, {
						product_id: item.id,
						id: null,//ID置空
						custom_fields_value_json: {}//自定义参数置空
					});
				}), {
					work_type_id: 21,
					source_list: data.map(item => {
						return [{
							ref_work_type_id: 7,
							ref_id: item.product_id
						}]
					})
				})
			);
		},
		
		/******打开选择产品批次库存弹窗*********/
		selectProductBatch(){
			if (this.warehouse_id == 0){
				this.$message({
					message:'请选择出库仓库',  // 提示内容,
					type: 'warn'
				});
			}else {
				this.globalDialog('productBatchSelector', {
					props: {
						warehouseOptions: [this.$refs.warehouse.getData()],
						isStock: true,
						disabledWarehouse: true
					}
				}, this.productBatchSelectorHandle)
			}
		},
		
		/******选择产品批次库存响应方法*********/
		async productBatchSelectorHandle(data) {
			//判断是否已存在于表格之中，已存在则不允许添加
			for (var i = 0; i < data.length; i++) {
				var newProduct = data[i];
				var existObj = this.$refs.productTable.$refs.list.getData().find(function (obj) {
					return obj.product_id == newProduct.product_id && obj.batch_id == newProduct.batch_id
				});
				if (existObj){
					this.$message({
						type:'warn',
						message:'产品【'+existObj.product_code+' | '+existObj.product_name+'】,批次【' + existObj.batch_code + '】已存在，请勿重复添加',
					});
					return;
				}
			}
			//处理数据
			this.$refs.productTable.$refs.list.push(
				await this.$refs.productTable.setDefaultData(data.map(item => {
					return Object.assign({}, item, {
						product_id: item.product_id,
						id: null,//ID置空
						custom_fields_value_json: {}//自定义参数置空
					});
				}), {
					work_type_id: 21,
					source_list: data.map(item => {
						return [{
							ref_work_type_id: 7,
							ref_id: item.product_id
						}]
					})
				})
			);
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			//出库商品
			var product_list = this.$refs.productTable.$refs.list.getData();
			this.$refs.stockoutForm.submit({
				url: this.order_id==0?'/stockout/order/add':'/stockout/order/edit',
				rule: {
					warehouse_id: '请选择出库仓库',
					order_classify: '请选择出库类型',
					storage_date: '请选择出库时间',
					product_list: data => {
						var flag = true;
						if(product_list.length == 0) return "请添加产品明细";
						product_list.forEach(item => {
							if(!item.view_product_count || isNaN(item.view_product_count) || item.view_product_count ==0){
								flag = false;
							}
						});
						if (!flag) {
							return '请完善产品明细';
						}
						//自定义字段校验
						return this.$refs.productTable.validate();
					},
					...this.$refs.customForm.rule
				},
			    dataFormatter: data => {
					data.id = this.order_id||0;
				    data.product_list  = product_list.map(item => {
					    return {
						    id:item.id,
						    product_id:item.product_id,
							batch_id: item.batch_id||0,
						    old_product_count:item.old_product_count,
						    view_product_count:item.view_product_count,
							product_price: parseFloat(item.product_price||0),
						    custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
					    }
				    });
					data.delete_product_list = this.deleteProductList;
				    data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
				    return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:this._editState ? '编辑出库单成功' : '创建出库单成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>